import axios from "../../../privateApi";

export const confirmPath = async (
  evoPathId: number,
  evolutionIdPath: number[],
) => {
  const res = await axios.post<{
    loading: boolean;
    availableEvos: number;
  }>(
    `/evolved-players/${evoPathId}/confirm-path?evolutionIdPath=${evolutionIdPath.join("-")}`,
  );
  return {
    loading: res.data.loading,
    availableEvos: res.data.availableEvos,
  };
};
